import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Nav } from "./site/Nav";
import { Hero } from "./site/Hero";
import { HowToBook } from "./site/HowToBook";
import { ChiSono } from "./site/ChiSono";
import { Expertise } from "./site/Expertise";
import { Methodology } from "./site/Methodology";
import { Transformations } from "./site/Transformations";
import { GoogleReviews } from "./site/GoogleReviews";
import { FAQ } from "./site/FAQ";
import { FinalCTA } from "./site/FinalCTA";
import { Footer } from "./site/Footer";

const Landing = () => {
  return (
    <div className="min-h-screen bg-white text-[#0E1A14]">
      <Nav />
      <main>
        <Hero />
        <HowToBook />
        <ChiSono />
        <Expertise />
        <Methodology />
        <Transformations />
        <GoogleReviews />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
